import axiosClient from './axiosClient';

export interface RequirementMatch {
  category: string;
  requirement: string;
  met: boolean;
  evidence?: string;
  gap?: string;
  recommendation?: string;
}

export interface ResumeScoreDto {
  id: string;
  opportunityId: string;
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
  fileName: string;
  fileSizeBytes?: number;
  overallScore?: number;
  summary?: string;
  strengths?: string[];
  gaps?: string[];
  recommendations?: string[];
  requirementScores?: RequirementMatch[];
  modelUsed?: string;
  tokensUsed?: number;
  errorMessage?: string;
  triggeredByName?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt?: string;
}

export const resumeScoreApi = {
  upload: (opportunityId: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post<ResumeScoreDto>(
      `/opportunities/${opportunityId}/resume-scores`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  },

  getAll: (opportunityId: string) =>
    axiosClient.get<ResumeScoreDto[]>(
      `/opportunities/${opportunityId}/resume-scores`,
    ),

  getOne: (opportunityId: string, scoreId: string) =>
    axiosClient.get<ResumeScoreDto>(
      `/opportunities/${opportunityId}/resume-scores/${scoreId}`,
    ),

  delete: (opportunityId: string, scoreId: string) =>
    axiosClient.delete(
      `/opportunities/${opportunityId}/resume-scores/${scoreId}`,
    ),
};
